<style scoped>
  .title-blue {
    background-color: rgb(81, 146, 247);
    height: 60px;
    padding: 5px 0 5px 0;
  }

  .left-arrow {
    padding-top: 17px;
    font-size: 25px;
    color: white;
  }
  .btn-row{
    margin-top: 20px;
    height: 50px;
    padding: 0 20px 0 20px;
  }
  .btn-left{
    height: 100%;
    padding: 14px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    font-weight: 500;
  }
  .btn-right{
    height: 100%;
    padding: 14px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    font-weight: 500;
  }
  .selected{
    background: rgb(81, 137, 247);
    color: white;
  }
  .UnSelected{
    color: rgb(81, 137, 247);
    background: white;
    border:1px solid rgb(81, 137, 247);
  }
  .title {
    text-align: left;
    padding: 10px 10px 15px 10px;
    color: rgb(85, 143, 247);
    font-weight: 500;
    border-bottom: 1px solid rgb(85, 143, 247);
    margin-top: 20px;
  }
  .list{
    font-weight: 500;
    padding: 10px 10px 15px 10px;
    text-align: left;
  }
</style>

<template>
  <div>
    <van-row class="title-blue">
      <van-col span="2" class="left-arrow">
        <van-icon name="arrow-left" @click="goBack"/>
      </van-col>
      <van-col span="18" style="padding-top: 5px">
        <van-search style="padding: 8px"
                    placeholder="请输入预约患者姓名"
                    shape="round"
                    background="rgb(81, 146, 247)"
                    v-model="value"
        />
      </van-col>
      <van-col span="4" style="padding-top: 20px;color: white;font-weight: 500" @click="getPatientListSearch()">搜索</van-col>
    </van-row>


    <van-row class="btn-row">
      <van-col span="12" class="btn-left" :class="executedStatus===0?'selected':'UnSelected'" @click="getUnExecutedList()">未执行</van-col>
      <van-col span="12" class="btn-right"  :class="executedStatus===0?'UnSelected':'selected'" @click="getExecutedList()">已执行</van-col>
    </van-row>

    <van-row class="title">
      <van-col span="6">患者</van-col>
      <van-col span="6">医技科室</van-col>
      <van-col span="6">预约项目</van-col>
      <van-col span="6">预约时间段</van-col>
    </van-row>

    <template v-if="executedStatus===1" v-for="(item,index) in executedList">
      <van-row class="list">
        <van-col span="6">{{item.name}}</van-col>
        <van-col span="6">{{item.detectionDepName}}</van-col>
        <van-col span="6">{{item.bookItemName}}</van-col>
        <van-col span="6">{{item.time}}</van-col>
      </van-row>
    </template>

    <template v-if="executedStatus===0" v-for="(item,index) in unExecutedList">
      <van-row class="list">
        <van-col span="6">{{item.name}}</van-col>
        <van-col span="6">{{item.detectionDepName}}</van-col>
        <van-col span="6">{{item.bookItemName}}</van-col>
        <van-col span="6">{{item.time}}</van-col>
      </van-row>
    </template>

  </div>
</template>

<script>
  import api from "@/axios/api";
  import { mapGetters, mapActions } from "vuex";
  export default {
    name: "director-detail",
    computed: {
      ...mapGetters(["token"])
    },
    watch: {
      token: {
        immediate: true,
        handler: function(val) {
          if (val) {
            this.getPatientListSearch();
          }
        }
      }
    },
    data() {
      return {
        value: '',
        //当前选中的状态 0未执行 1已执行
        executedStatus : 0,
        bookTime : this.$route.query.bookTime,
        detectionDepId:this.$route.query.detectionDepId,
        precise:this.$route.query.precise,
        //执行列表
        executedList: [],
        //未执行列表
        unExecutedList: []
      }
    },
    created: function () {
      //初始化时只要加载未执行列表
      this.getPatientListSearch();
    },
    methods: {
      //加载列表
      getPatientListSearch(){
        this.executedList = []
        this.unExecutedList= []
        api.getPatientListSearch(this.bookTime,this.detectionDepId,this.precise,this.value).then(res => {
          this.executedList=res.executedList;
          this.unExecutedList=res.unExecutedList;
        });
      },
      getExecutedList(){
        this.executedStatus=1;
      },
      getUnExecutedList(){
        this.executedStatus=0;
      },
      //回退
      goBack(){
        this.$router.go(-1);
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/hospital-admin/pages/director-detail.vue